import { args_type, http_request_worker_type, result_type, set_db_type } from '../interfaces';

/**
 * @param {string} url
 * @param {number} method_id
 * @param {string} [body]
 * @param {string} [kind]
 * @param {string} [unit]
 * @param {1} [is_string]
 * @return {*}  {Promise<any>}
 */
declare const http_request_worker: http_request_worker_type;
declare const set_db: set_db_type;
declare const close: Function;

/**
 * http_request 在 web worker 裡的主程式，控制整個 http 請求流程
 * @param {args_type} args 從 http-func.tsx 傳進來的參數，為一個 object
 */
export function http_request_func(args: args_type) {
  const { url, method, body, key, subscription_id, unit, refresh_url, is_string, content_type, no_sorting, no_underlined_key }: args_type = args;

  let urls: string[] = typeof url === 'string' ? [url] : url;
  urls = urls.map((url_each: string) => `${url_each}${subscription_id ? `${key === 'subscriptions' ? '&' : '?'}subscriptionId=${subscription_id}` : ''}`);

  try {
    const promises = urls.map(
      (url: string) =>
        new Promise((resolve: (value?: unknown) => void) => {
          http_request_worker(url, method, body, key, unit, is_string, content_type, no_sorting, no_underlined_key)
            .then((response: result_type) => {
              const { result } = response;
              const code = (result as { code: number }).code;

              //@ts-ignore
              postMessage(JSON.stringify([is_string && !code ? result : Object.assign({ code, message: response.message }, result)]));

              !method && !code && !['login', 'validation', 'user_info'].includes(key)
                ? set_db(key, result).finally(() => {
                    resolve();
                  })
                : resolve();
            })
            .catch(() => {
              resolve();
            });
        })
    );

    Promise.all(promises).finally(() => {
      // @ts-ignore
      postMessage('done');
      // 如果是 POST, PUT, DELETE, PATCH，需要再更新列表
      if (method > 0 && !args.no_refresh) {
        if (refresh_url) urls[0] = refresh_url;
        else if (method > 1) {
          const str: string = urls[0].substring(urls[0].lastIndexOf('/'));
          urls[0] = urls[0].replace(str, '');
        }

        http_request_worker(urls[0], 0, body, key, unit, is_string, content_type, no_sorting, no_underlined_key)
          .then(({ result }: result_type) => {
            // @ts-ignore
            postMessage(JSON.stringify([result]));
            set_db(key, result).finally((): void => {
              // @ts-ignore
              postMessage('end');
              setTimeout(() => {
                close();
              }, 0); // 結束 Worker
            });
          })
          .catch(() => {
            // @ts-ignore
            postMessage('end');
            setTimeout(() => {
              close();
            }, 0); // 結束 Worker
          });
      } else {
        // @ts-ignore
        postMessage('end');
        setTimeout(() => {
          close();
        }, 0); // 結束 Worker
      }
    });
  } catch (err) {
    console.error(err);
  }
}
